import makeStyles from '@mui/styles/makeStyles';
import { FC } from 'react';
import InsertPageBreakIcon from '@mui/icons-material/InsertPageBreak';
import { mainColors } from '../../../../../styling/theme';
import UtilityButtons from '../buttons/UtilityButtons.component';
import KidsEditorGridItem from '../../kidsV2/layout/KidsEditorGridItem.component';
import KidsFieldTypeSelect from '../buttons/KidsFieldTypeSelect.component';
import { EditorTileProps } from '../../kids/editor/editorTiles/KidsEditorColumn.component';

const useStyles = makeStyles(() => ({
  pageBreakIconBox: {
    marginTop: '1.25rem',
    marginBottom: '1.25rem',
    marginLeft: '0.62rem',
    fontSize: '0.94rem',
    boxSizing: 'border-box',
    padding: '0.62rem',
    borderRadius: '6px',
    width: '100%',
    minHeight: '6.25rem',
    display: 'flex',
    justifyContent: 'space-around',
  },
  editorContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    marginRight: '0.62rem',
  },
  formatContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
    paddingTop: '0.62rem',
  },
}));

const PageBreakEditorTile: FC<EditorTileProps> = ({
  priipsKidsElement,
  updateFieldType,
  moveField,
  deleteField,
}) => {
  // Store the index of the current element in the overall data
  const index = priipsKidsElement.kiidIndex;
  // Store the field ID of the element
  const fieldId = priipsKidsElement.fieldId;
  const classes = useStyles();

  return (
    <KidsEditorGridItem xs={12}>
      <div className={classes.formatContainer}>
        {/* This is a hacky solution to fill in for the style format buttons that is on other tiles. */}
        {/* TODO: Refactor this to use the same component as other tiles. Use a general tile wrapper? */}
        <div style={{ width: '100%' }}></div>
        <KidsFieldTypeSelect
          initialType={priipsKidsElement.tag}
          updateFieldType={updateFieldType}
          index={priipsKidsElement.kiidIndex}
        />
      </div>
      <div className={classes.editorContainer}>
        <div className={classes.pageBreakIconBox}>
          <InsertPageBreakIcon
            sx={{
              color: mainColors.mainBlue,
              fontSize: '6.25rem',
              cursor: 'pointer',
              backgroundColor: 'white',
              border: '1px solid',
              borderColor: mainColors.mainBlue,
              borderRadius: 4,
            }}
          />
        </div>
        <UtilityButtons
          moveField={moveField}
          index={index}
          deleteField={deleteField}
          fieldId={fieldId}
        />
      </div>
    </KidsEditorGridItem>
  );
};

export default PageBreakEditorTile;
